import type { AgentSopSummary } from '@erp/rpc';
import { cn } from '@/lib/utils';
import { sopKey, sopLabel } from './procedureDisplay';

/**
 * A procedure's picker label: its title with the unique kebab `name` beneath in muted monospace.
 * Titles are not unique, so pickers that list procedures render this rather than the title alone.
 */
export function ProcedureOptionLabel({
  sop,
  className,
}: {
  sop: AgentSopSummary;
  className?: string;
}) {
  const key = sopKey(sop);
  return (
    <span className={cn('block min-w-0', className)}>
      <span className="block truncate">{sopLabel(sop)}</span>
      {key ? (
        <span className="block truncate font-mono text-[11px] font-normal text-muted-foreground">
          {key}
        </span>
      ) : null}
    </span>
  );
}
